import { render, staticRenderFns } from "./GLAOrganisation.vue?vue&type=template&id=feb0cff4&scoped=true&"
import script from "./GLAOrganisation.vue?vue&type=script&lang=js&"
export * from "./GLAOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./GLAOrganisation.vue?vue&type=style&index=0&id=feb0cff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb0cff4",
  null
  
)

export default component.exports